import { fg } from '@atlaskit/platform-feature-flags';
import { IconTypes } from './types';
var isMarkInIconTypes = function isMarkInIconTypes(node) {
  return node.marks.some(function (mark) {
    return Object.values(IconTypes).includes(mark.type.name);
  });
};
export var hasMultiplePartsWithFormattingInSelection = function hasMultiplePartsWithFormattingInSelection(_ref) {
  var selectedContent = _ref.selectedContent;
  if (!selectedContent) {
    return false;
  }
  if (fg('platform_editor_controls_patch_8')) {
    // Check if there are multiple parts with formatting or if only one part has formatting and the rest have none
    var contentWithMarks = selectedContent.filter(function (child) {
      return isMarkInIconTypes(child);
    });
    var hasFormatting = contentWithMarks.length > 0;
    var allPartsHaveFormatting = contentWithMarks.length === selectedContent.length;
    return hasFormatting && (!allPartsHaveFormatting || contentWithMarks.length > 1);
  }
  var marks = selectedContent.map(function (child) {
    return isMarkInIconTypes(child) ? child.marks : undefined;
  }).filter(Boolean);
  return marks.length > 1;
};